import { useEffect } from "react";
import { Dialog, List, RadioButton } from "react-native-paper";
import type { IconType } from "../../icon";
import Box from "../Box";
import DialogWrapper from "../DialogWrapper";
import ListBottomSheetWrapper from "../ListBottomSheetWrapper";

type SortItem = {
	label: string;
	icon: string;
	type: string;
};

type Props = {
	showModal: boolean;
	handleSheetClose: () => void;
	sortItems: SortItem[];
	currentSortType: string;
	handleSelectSortItem: (type: string) => void;
	onOpen?: () => void;
	title?: string;
	icon?: IconType;
	presentation?: "sheet" | "dialog";
};

const SortModalContainer = ({
	showModal,
	handleSheetClose,
	sortItems,
	currentSortType,
	handleSelectSortItem,
	onOpen,
	title = "Sort by",
	icon,
	presentation = "sheet",
}: Props) => {
	useEffect(() => {
		if (showModal) {
			onOpen?.();
		}
	}, [showModal, onOpen]);

	const content = (
		<Box paddingBottom={24}>
			{sortItems.map((item) => {
				const isSelected = item.type === currentSortType;
				return (
					<List.Item
						key={item.label}
						title={item.label}
						left={(props) => <List.Icon {...props} icon={item.icon} />}
						onPress={() => {
							handleSelectSortItem(item.type);
						}}
						right={(props) => (
							<RadioButton.Android
								{...props}
								value={item.type}
								onPress={() => {
									handleSelectSortItem(item.type);
								}}
								status={isSelected ? "checked" : "unchecked"}
							/>
						)}
					/>
				);
			})}
		</Box>
	);

	if (presentation === "dialog") {
		return (
			<DialogWrapper
				visible={showModal}
				handleClose={handleSheetClose}
				width={420}
			>
				{icon ? <Dialog.Icon icon={icon} aria-label={title} /> : null}
				<Dialog.Title style={{ textAlign: icon ? "center" : "left" }}>
					{title}
				</Dialog.Title>
				{content}
			</DialogWrapper>
		);
	}

	return (
		<ListBottomSheetWrapper
			showModal={showModal}
			title={title}
			snapPoints={["55%", "80%"]}
			handleSheetClose={handleSheetClose}
		>
			{content}
		</ListBottomSheetWrapper>
	);
};

export default SortModalContainer;
